import { ModuleRouter } from "@/components/module-router/module-router";

export function TemporaryRoutes() {
  return <ModuleRouter moduleId="ram-temporary" />;
}
